var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_493_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4185 0.081009L1.35463 3.69976C0.962267 3.81752 0.618899 4.05534 0.375046 4.37824C0.131193 4.70114 -0.000268975 5.09207 4.13191e-07 5.49351V10.556C-9.468e-06 14.7047 1.26611 18.7591 3.63619 22.1997C6.00627 25.6403 9.37242 28.3106 13.3035 29.8685C13.7533 30.041 14.2531 30.041 14.7029 29.8685C18.6323 28.3089 21.9966 25.638 24.3654 22.1976C26.7342 18.7573 27.9997 14.7038 28 10.556V5.49351C28.0003 5.09207 27.8688 4.70114 27.625 4.37824C27.3811 4.05534 27.0377 3.81752 26.6454 3.69976L14.5687 0.081009C14.1937 -0.0302582 13.7935 -0.0302582 13.4185 0.081009Z",
    fill: "url(#paint0_linear_493_280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0.0001331V30.0001C13.7614 30.0002 13.525 29.9556 13.3035 29.8689C9.37242 28.3109 6.00627 25.6406 3.63619 22.2C1.26611 18.7594 -9.468e-06 14.7051 4.13191e-07 10.5564V5.49388C-0.000268975 5.09244 0.131193 4.70151 0.375046 4.37861C0.618899 4.05571 0.962267 3.81789 1.35463 3.70013L13.4185 0.0813831C13.6069 0.0252427 13.8031 -0.00216225 14 0.0001331Z",
    fill: "url(#paint1_linear_493_280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0062 27.4438C10.6057 26.0499 7.70346 23.7021 5.66561 20.6966C3.62777 17.6911 2.54563 14.1626 2.55573 10.5563V5.95625L14.0062 2.53125L25.4439 5.95625V10.5563C25.4551 14.1612 24.3748 17.6887 22.3394 20.694C20.3039 23.6993 17.4043 26.0479 14.0062 27.4438Z",
    fill: "url(#paint2_linear_493_280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 2.53125V27.4438C10.6 26.0496 7.69866 23.7016 5.6619 20.696C3.62514 17.6904 2.54428 14.1621 2.55575 10.5563V5.95625L13.9998 2.53125Z",
    fill: "url(#paint3_linear_493_280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2503 10.0961L17.5003 10.9615L11.667 9.80762L9.04199 15.6875L18.5304 24.8125C21.5068 22.4668 23.6712 19.2803 24.7285 15.6875L19.2503 10.0961Z",
    fill: "url(#paint4_linear_493_280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4378 7.64364L17.1503 5.76864C17.1084 5.75633 17.0693 5.73606 17.0353 5.70898C17.0014 5.6819 16.9732 5.64855 16.9525 5.61082C16.9105 5.53464 16.9012 5.44527 16.9267 5.36239C16.9521 5.27951 17.0101 5.2099 17.088 5.16888C17.1659 5.12786 17.2573 5.11878 17.342 5.14364L23.6232 7.01864C23.7038 7.0445 23.7709 7.1001 23.8103 7.17364C23.8497 7.24717 23.8582 7.33283 23.834 7.41239C23.8244 7.45348 23.8063 7.49223 23.7809 7.52631C23.7556 7.56039 23.7234 7.5891 23.6864 7.6107C23.6494 7.63231 23.6083 7.64636 23.5656 7.65202C23.5228 7.65768 23.4794 7.65483 23.4378 7.64364Z",
    fill: "url(#paint5_linear_493_280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7218 9.58403L17.5076 10.4349C16.5689 9.31334 15.178 8.65381 13.7444 8.65381C10.9905 8.65381 8.75 10.9831 8.75 13.8461C8.75 16.7092 10.9905 19.0384 13.7444 19.0384C15.5023 19.0384 17.098 18.1055 18.0131 16.5429L16.6629 15.6939C16.0366 16.7634 14.9456 17.4019 13.7444 17.4019C11.8614 17.4019 10.3293 15.8068 10.3293 13.8461C10.3293 11.8855 11.8614 10.2904 13.7444 10.2904C14.803 10.2904 15.7834 10.8098 16.4197 11.6402L15.1967 11.5083L15.0332 13.1361L17.6948 13.4231C17.7224 13.4261 17.7499 13.4276 17.7771 13.4276C18.1326 13.4276 18.4492 13.1791 18.5406 12.8158L19.25 9.99701L17.7218 9.58403Z",
    fill: "url(#paint6_linear_493_280)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_493_280",
    x1: 14.1853,
    y1: -18.0627,
    x2: 13.5984,
    y2: 68.0749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F5FCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#DAF3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B9E8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8CD9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71D0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_493_280",
    x1: 7.36741,
    y1: -33.8936,
    x2: 6.78054,
    y2: 52.2441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F5FCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#DAF3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B9E8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8CD9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71D0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_493_280",
    x1: 14.1084,
    y1: 1.61875,
    x2: 13.6438,
    y2: 31.6191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C48C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_493_280",
    x1: 8.03818,
    y1: -11.4375,
    x2: 8.57616,
    y2: 30.0941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C48C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_493_280",
    x1: 21.2269,
    y1: 19.7875,
    x2: 10.5126,
    y2: 9.3195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3EBA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C48C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_493_280",
    x1: 7.66788,
    y1: -0.956357,
    x2: 22.3078,
    y2: 7.89618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_493_280",
    x1: 18.5768,
    y1: 8.8264,
    x2: -2.96423,
    y2: 20.3718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F5FCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#DAF3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B9E8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8CD9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71D0E6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_493_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSettings);
export default __webpack_public_path__ + "static/media/not-settings.e2cee7da968d174db581b7b24eea41a8.svg";
export { ForwardRef as ReactComponent };